import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import UserProfileState, { UserProfile } from './states'

const userProfile: Module<UserProfileState, State> = {
  state: new UserProfileState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default userProfile
